import { render, staticRenderFns } from "./TheTopNavbarVertical.vue?vue&type=template&id=d705b228"
import script from "./TheTopNavbarVertical.vue?vue&type=script&lang=js"
export * from "./TheTopNavbarVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports